import { EndPoints } from '../../common/enums/enums';
import { api } from './api';

export const departmentServices = api.injectEndpoints({
  endpoints: build => ({
    getDepartmentsByCompany: build.query({
      query: () => EndPoints.BULK_EXPORT.BULK_DEPARTMENTS.ENDPOINT,
      transformResponse: response => response.departments,
    }),
    getDepartmentsByUser: build.query({
      query: companyId =>
        EndPoints.USERS.GET_DEPARTMENTS.replace('{companyId}', companyId),
      transformResponse: response => response.departments,
    }),
  }),
});

export const { useGetDepartmentsByCompanyQuery, useGetDepartmentsByUserQuery } =
  departmentServices;
